
import Vue, { PropType } from 'vue'
import ProfileImage from '@/components/forms/ProfileImage.vue'
import { billingInformationIsCorrect } from '@/services/user'
import { UserProxy } from '@/api/types/user'
import { Environment } from '@/api/types/base'

export default Vue.extend({
  name: 'UserCard',
  props: {
    user: {
      type: Object as PropType<UserProxy>,
      required: true,
    },
  },
  components: {
    ProfileImage,
  },
  computed: {
    mailUrl(): string {
      return `mailto: ${this.user.email}`
    },
    workstationsCount(): number {
      return this.user.workstations.length
    },
    drivesCount(): number {
      return this.user.drives.length
    },
    runningWorkstationsCount(): number {
      return this.user.runningWorkstations.length
    },
    env(): Environment {
      return this.user.profile.environment || 'prod'
    },
    paymentMethod(): boolean {
      return billingInformationIsCorrect(this.user.profile)
    },
  },
  methods: {
    goToActivity() {
      this.$store.dispatch('admin/goToActivity', this.user.uid)
    },
    openResources() {
      this.$modal.show('user-resources', { user: this.user })
    },
  },
})
